import Insights from './Insights';
import ProgressionOverTime from './ProgressionOverTime/ProgressionOverTime';
import ProgressionTable from './ProgressionTable';
import {
  StyledChartRow,
  StyledProgressionOverTimeWrapper,
  StyledInsightsWrapper,
  StyledProgressionTableWrapper,
  StyledProjectProgression
} from './ProjectProgression.style';
import useAmplitudeVisit from 'common/hooks/tracking/useAmplitudeVisit';
import { TRACKING } from 'common/constants/constants';
import useEmptyStateType from './empty-state/useEmptyStateType';
import EmptyState from './empty-state/EmptyState';

const ProjectProgression = () => {
  useAmplitudeVisit({ page: TRACKING.PAGES.PROJECT_PROGRESSION });
  const emptyStateType = useEmptyStateType();

  if (emptyStateType) return <EmptyState type={emptyStateType} />;

  return (
    <StyledProjectProgression>
      <StyledChartRow>
        <StyledProgressionOverTimeWrapper>
          <ProgressionOverTime />
        </StyledProgressionOverTimeWrapper>
        <StyledInsightsWrapper>
          <Insights />
        </StyledInsightsWrapper>
      </StyledChartRow>

      <StyledProgressionTableWrapper>
        <ProgressionTable />
      </StyledProgressionTableWrapper>
    </StyledProjectProgression>
  );
};

export default ProjectProgression;
